const videoHeros = document.querySelectorAll(".video-hero");
videoHeros.forEach((videoHero) => {
    initVideoHero(videoHero);
});

function initVideoHero(hero_el) {
    const images = [...hero_el.querySelectorAll("[data-bg-image]")];
    if (images.length) {
        window.setInterval(() => {
            const active_element = images.find((image) =>
                image.classList.contains("show"),
            );
            const active_index = images.indexOf(active_element);
            images.forEach((image) => {
                image.classList.add("hide");
                image.classList.remove("show");
            });

            const new_active = images[(active_index + 1) % images.length];
            new_active?.classList.add("show");
            new_active?.classList.remove("hide");
        }, 6000);
    }
}
